module.exports = __webpack_public_path__ + "static/media/mother_cover.66393ccb.mp4";